import { render, staticRenderFns } from "./data-list.vue?vue&type=template&id=06f442df&scoped=true"
import script from "./data-list.vue?vue&type=script&lang=js"
export * from "./data-list.vue?vue&type=script&lang=js"
import style0 from "./data-list.vue?vue&type=style&index=0&id=06f442df&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f442df",
  null
  
)

export default component.exports